import { Navigate, Route, Routes } from "react-router-dom";
import WelcomePage from "@/pages/welcome";
import KitPage from "@/pages/kit";
import PatientReportLayout from "@/pages/patient/report/layout";
import PatientReportSummary from "@/pages/patient/report/summary";
import PatientReportChatLayout from "@/pages/patient/report/chat-layout";
import PatientReportChatSession from "@/pages/patient/report/chat-session";

export default function App() {
  return (
    <Routes>
      <Route path="/r/:token" element={<PatientReportLayout />}>
        <Route index element={<PatientReportSummary />} />
        <Route path="s" element={<PatientReportChatLayout />}>
          <Route path=":sessionId" element={<PatientReportChatSession />} />
        </Route>
      </Route>

      <Route path="/kit" element={<KitPage />} />

      <Route path="/" element={<WelcomePage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
